import React from "react";
import Lottie from "lottie-react";

import LoaderAnimation from "../../assets/loaders/MainLoader.json";

const MainLoader = ({ style = { height:200, width: 250 }, loop = true }) => {
	return <Lottie animationData={LoaderAnimation} loop={loop} style={style} />;
};

export default MainLoader;
